import styled from 'styled-components'

import { TextField } from '@ui/elements/TextField'

export const StatusIconWrapperStyled = styled.span`
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
`

export const InlineEditTextFieldStyled = styled(TextField)`
  input.nativeInput {
    padding-right: 2rem;
  }

  &&& .input:not(.Mui-focused) {
    background: transparent;
    border-color: transparent;

    .MuiOutlinedInput-notchedOutline {
      border-color: transparent;
    }

    &:hover {
      border-color: transparent;

      .MuiOutlinedInput-notchedOutline {
        border-color: transparent;
      }
    }
  }

  ${StatusIconWrapperStyled} {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 0.5rem;
  }
`
